import { render } from "./CustomDialog.vue?vue&type=template&id=51444502&scoped=true"
import script from "./CustomDialog.vue?vue&type=script&lang=js"
export * from "./CustomDialog.vue?vue&type=script&lang=js"

import "./CustomDialog.vue?vue&type=style&index=0&id=51444502&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51444502"]])

export default __exports__